import React from 'react';
import { PictoProps } from './index';

export const Navigation = (props: PictoProps) => (
  <svg
    width={props.width || '23'}
    height={props.height || '23'}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.4443 1.61328L10.4443 12.6133"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.4443 1.61328L14.4443 21.6133L10.4443 12.6133L1.44434 8.61328L21.4443 1.61328V1.61328Z"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
